import Reveal from "@/components/Reveal";
import { IMAGES } from "@/lib/data";

const CHAPTERS = [
  {
    num: "01",
    title: "Precision Diagnostics",
    body: "We measure before we touch. Every visit starts with instrumented testing — voltage, amperage, temperature curves — so we fix the cause, not the symptom.",
  },
  {
    num: "02",
    title: "Authentic Components",
    body: "OEM and factory-certified parts only. Your Sub-Zero deserves what it was built with, and anything less voids the engineering you paid for.",
  },
  {
    num: "03",
    title: "Calibrated Tolerances",
    body: "Leveled, balanced, torqued to spec. Before we leave, every repair is verified against manufacturer tolerances — doors aligned, flames true, drums silent.",
  },
  {
    num: "04",
    title: "Lifetime Craft Promise",
    body: "Every repair carries a 90-day warranty and our name. If our workmanship ever fails, we return and make it right at no cost to you.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E06A26] mb-5">The Thortek standard</p>
              <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
                A repair is a craft. We treat it like one.
              </h2>
              <p className="text-[#94A0AC] text-base leading-relaxed mt-6 max-w-md">
                Four commitments, made on every single work order since day one.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="clip-frame overflow-hidden border border-white/10 mt-10 spotlight relative hidden lg:block">
                <img
                  src={IMAGES.dishwasher}
                  alt="Technician servicing appliance controls"
                  data-testid="manifesto-image"
                  className="w-full h-[300px] object-cover img-spot"
                />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div
                data-testid={`manifesto-chapter-${c.num}`}
                className="group border-t border-white/10 py-10 flex gap-8 items-start transition-colors duration-500 hover:border-[#E06A26]/30"
              >
                <span className="font-mono text-3xl sm:text-4xl font-semibold text-[#E06A26]/90 shrink-0 w-16 transition-transform duration-500 group-hover:-translate-y-1">
                  {c.num}
                </span>
                <div>
                  <h3 className="font-display text-xl sm:text-2xl font-medium mb-3">{c.title}</h3>
                  <p className="text-sm sm:text-base text-[#94A0AC] leading-relaxed max-w-lg">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
